import { getUser } from '@/common/utils.ts'
const userInfo = getUser()
const config = {
  rowSelection: true,
  columns: [
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 180,
      render: 'clueIdRender',
    },
    {
      title: '需求标签',
      dataIndex: 'bizTag',
      render: 'bizTagRender',
      width: 110
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      ellipsis: true,
      width: 100
    },
    {
      title: '主合同号',
      dataIndex: 'contractNo',
      ellipsis: true,
      width: 160
    },
    {
      title: '电话号码',
      dataIndex: 'customerPhone',
      ellipsis: true,
      width: 120
    },
    {
      title: '服务地址',
      dataIndex: 'serviceAddressName',
      ellipsis: true,
      width: 180
    },
    {
      title: '设计师',
      dataIndex: 'designerName',
      ellipsis: true,
      width: 100
    },
    {
      title: '营销员',
      dataIndex: 'salesmanName',
      ellipsis: true,
      width: 100
    },
    {
      title: '线索ID',
      dataIndex: 'clueId',
      ellipsis: true,
      width: 180
    },
    {
      title: '项目经理',
      dataIndex: 'pmRelativesName',
      ellipsis: true,
      width: 100
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatusName',
      render: 'statusRender',
      width: 110
    },
    {
      title: '订单/合同金额',
      dataIndex: 'orderAmount',
      width: 130
    },
    {
      title: '应收金额合计',
      dataIndex: 'receivableAmount',
      width: 130
    },
    // {
    //   title: '实收金额合计',
    //   dataIndex: 'receiveAmount',
    //   width: 130
    // },
    {
      title: '应收余额合计',
      dataIndex: 'unReceiveAmount',
      width: 130
    },
    {
      title: '支付状态',
      dataIndex: 'payStatusName',
      width: 120,
    },
    {
      title: '门店',
      dataIndex: 'companyOrgName',
      ellipsis: true,
      width: 160
    },
    {
      title: '财务主体',
      dataIndex: 'companyConfigName',
      ellipsis: true,
      width: 220
    },
  ],
  search: [
    {
      name: 'customerName',
      label: '客户姓名',
      placeholder: '客户姓名',
    },
    {
      name: 'customerPhone',
      label: '电话号码',
      placeholder: '电话号码',
    },
    {
      name: 'serviceAddressLike',
      label: '服务地址',
      placeholder: '服务地址',
    },
    {
      name: 'contractNo',
      label: '主合同号',
      placeholder: '主合同号',
    },
    {
      name: 'orderNoPrefix',
      label: '订单号',
      placeholder: '订单号',
    },
    {
      name: 'payStatus',
      label: '支付状态',
      placeholder: '支付状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'orderPayStateList',
      allowClear: true,
    },
    {
      name: 'orderStatus',
      label: '订单状态',
      placeholder: '订单状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'orderStateList',
      allowClear: true,
    },
    {
      name: 'bizTag',
      label: '需求标签',
      placeholder: '需求标签',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'demandList',
      allowClear: true,
    },
    {
      name: 'companyConfigId',
      label: '财务主体',
      placeholder: '财务主体',
      itemType: 'select',
      key: 'companyConfigId',
      labelKey: 'companyFullName',
      data: 'esignCompanyList',
    },
    {
      name: 'companyOrgIdList',
      label: '门店',
      placeholder: '门店',
      itemType: 'select',
      key: 'orgId',
      labelKey: 'companyName',
      data: 'companyList',
      mode: 'multiple',
    },
  ],
  searchInitialValues: {
    'companyOrgIdList': userInfo?.companyName?.includes('总部') ? [] : [userInfo?.companyId]
  },
  footer: [
    {
      label: '收款计划异常数据',
      auth: 'AbnormalErrorList',
      render: 'abnormalErrorList',
    },
  ],
  batchActions: [
    {
      label: '更新金蝶客户',
      type: 'primary',
      auth: 'UpdateKingdeeCustomers',
      events: ['onClick:updateCustomers'],
    }
  ]
}

export default config
